import React, { useMemo, useState } from 'react';
import { getAllAlerts } from '../../utils/riskAlerts';
import './RiskAlertBanner.css';

export default function RiskAlertBanner({ scores }) {
  const [dismissed, setDismissed] = useState(false);
  const alerts = useMemo(() => getAllAlerts(scores || []), [scores]);

  if (dismissed || alerts.length === 0) return null;

  return (
    <div className="risk-alert-banner">
      <div className="rab-header">
        <span className="rab-title">Risk Alerts ({alerts.length})</span>
        <button className="rab-dismiss" onClick={() => setDismissed(true)}>&times;</button>
      </div>
      <div className="rab-alerts">
        {alerts.map((alert, i) => (
          <div key={i} className={`rab-alert ${alert.severity}`}>
            <span className="rab-icon">{alert.severity === 'high' ? '!' : '~'}</span>
            <span>{alert.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
